module.exports = __webpack_public_path__ + "img/160032.36a52f50.png";